import React from 'react';
import { Badge } from 'react-bootstrap';
import { ItemList } from 'v2/models';

interface SearchFilterProps {
  label: string;
  value: string[] | string | boolean | ItemList;
}

const SearchFilter = ({ label, value }: SearchFilterProps) => {
  return (
    <>
      <label>{label}</label>
      <p className="text-light2">
        {Array.isArray(value)
          ? value.map((item) => (
              <Badge key={item} className="mr-2" variant="light2">
                {item}
              </Badge>
            ))
          : value}
      </p>
    </>
  );
};

export default SearchFilter;
